import { render } from "./SortIcon.vue?vue&type=template&id=abc174d6"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"

import "./SortIcon.vue?vue&type=style&index=0&id=abc174d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__